module.exports = {
  "bColordanger": "#dd2222",
  "bColordangerlight": "#ffcccc",
  "bColorinfo": "#4499ee",
  "bColorinfolight": "#eeffff",
  "bColorneutral01": "#ffffff",
  "bColorneutral02": "#f8f8f8",
  "bColorneutral03": "#eeeeee",
  "bColorneutral04": "#cccccc",
  "bColorneutral05": "#aabbbb",
  "bColorneutral06": "#778888",
  "bColorneutral07": "#556666",
  "bColorneutral08": "#334444",
  "bColorneutral09": "#111515",
  "bColorprimary01": "#99ccbb",
  "bColorprimary02": "#66bb99",
  "bColorprimary03": "#11bb77",
  "bColorprimary04": "#228855",
  "bColorprimary05": "#005533",
  "bColorsecondary01": "#ddeeff",
  "bColorsecondary02": "#ccddee",
  "bColorsecondary03": "#99bbdd",
  "bColorsecondary04": "#6699dd",
  "bColorsecondary05": "#3377bb",
  "bColorsecondary06": "#005599",
  "bColorsecondary07": "#113377",
  "bColorsuccess": "#00dd88",
  "bColorsuccesslight": "#ddffee",
  "bColorwarning": "#ff7711",
  "uSurfaceDisabled": "#f8f8f8",
  "uSurfaceFloating": "#ffffff",
  "uSurfaceHover": "#ffffff",
  "uSurfacePressed": "#ccddee",
  "uSurfaceRested": "#ffffff",
  "uSurfaceSelected": "#ddeeff",
  "uSurfaceShadow": "#ffffff",
  "bHeadingh1FontSize": "72px",
  "bHeadingh1Color": "#334444",
  "bHeadingh1LineHeight": "80px",
  "bHeadingh1FontFamily": "Nunito",
  "bHeadingh1FontWeight": "600",
  "bHeadingh1TextAlign": "left",
  "bHeadingh1FallbackFontSize": "72px",
  "bHeadingh1FallbackColor": "#334444",
  "bHeadingh1FallbackLineHeight": "80px",
  "bHeadingh1FallbackFontFamily": "Tahoma",
  "bHeadingh1FallbackFontWeight": "400",
  "bHeadingh1FallbackTextAlign": "left",
  "bHeadingh1SystemFontSize": "72px",
  "bHeadingh1SystemColor": "#334444",
  "bHeadingh1SystemLineHeight": "80px",
  "bHeadingh1SystemFontFamily": "Tahoma",
  "bHeadingh1SystemFontWeight": "400",
  "bHeadingh1SystemTextAlign": "left",
  "bHeadingh2FontSize": "56px",
  "bHeadingh2Color": "#334444",
  "bHeadingh2LineHeight": "64px",
  "bHeadingh2FontFamily": "Nunito",
  "bHeadingh2FontWeight": "600",
  "bHeadingh2TextAlign": "left",
  "bHeadingh2FallbackFontSize": "56px",
  "bHeadingh2FallbackColor": "#334444",
  "bHeadingh2FallbackLineHeight": "64px",
  "bHeadingh2FallbackFontFamily": "Tahoma",
  "bHeadingh2FallbackFontWeight": "400",
  "bHeadingh2FallbackTextAlign": "left",
  "bHeadingh2SystemFontSize": "56px",
  "bHeadingh2SystemColor": "#334444",
  "bHeadingh2SystemLineHeight": "64px",
  "bHeadingh2SystemFontFamily": "Tahoma",
  "bHeadingh2SystemFontWeight": "400",
  "bHeadingh2SystemTextAlign": "left",
  "bHeadingh3FontSize": "40px",
  "bHeadingh3Color": "#334444",
  "bHeadingh3LineHeight": "48px",
  "bHeadingh3FontFamily": "Nunito",
  "bHeadingh3FontWeight": "600",
  "bHeadingh3TextAlign": "left",
  "bHeadingh3FallbackFontSize": "40px",
  "bHeadingh3FallbackColor": "#334444",
  "bHeadingh3FallbackLineHeight": "48px",
  "bHeadingh3FallbackFontFamily": "Tahoma",
  "bHeadingh3FallbackFontWeight": "400",
  "bHeadingh3FallbackTextAlign": "left",
  "bHeadingh3SystemFontSize": "40px",
  "bHeadingh3SystemColor": "#334444",
  "bHeadingh3SystemLineHeight": "48px",
  "bHeadingh3SystemFontFamily": "Tahoma",
  "bHeadingh3SystemFontWeight": "400",
  "bHeadingh3SystemTextAlign": "left",
  "bHeadingh4FontSize": "32px",
  "bHeadingh4Color": "#334444",
  "bHeadingh4LineHeight": "40px",
  "bHeadingh4FontFamily": "Nunito",
  "bHeadingh4FontWeight": "600",
  "bHeadingh4TextAlign": "left",
  "bHeadingh4FallbackFontSize": "32px",
  "bHeadingh4FallbackColor": "#334444",
  "bHeadingh4FallbackLineHeight": "40px",
  "bHeadingh4FallbackFontFamily": "Tahoma",
  "bHeadingh4FallbackFontWeight": "400",
  "bHeadingh4FallbackTextAlign": "left",
  "bHeadingh4SystemFontSize": "32px",
  "bHeadingh4SystemColor": "#334444",
  "bHeadingh4SystemLineHeight": "40px",
  "bHeadingh4SystemFontFamily": "Tahoma",
  "bHeadingh4SystemFontWeight": "400",
  "bHeadingh4SystemTextAlign": "left",
  "bHeadingh5FontSize": "24px",
  "bHeadingh5Color": "#334444",
  "bHeadingh5LineHeight": "32px",
  "bHeadingh5FontFamily": "Nunito",
  "bHeadingh5FontWeight": "600",
  "bHeadingh5TextAlign": "left",
  "bHeadingh5FallbackFontSize": "24px",
  "bHeadingh5FallbackColor": "#334444",
  "bHeadingh5FallbackLineHeight": "32px",
  "bHeadingh5FallbackFontFamily": "Tahoma",
  "bHeadingh5FallbackFontWeight": "400",
  "bHeadingh5FallbackTextAlign": "left",
  "bHeadingh5SystemFontSize": "24px",
  "bHeadingh5SystemColor": "#334444",
  "bHeadingh5SystemLineHeight": "32px",
  "bHeadingh5SystemFontFamily": "Tahoma",
  "bHeadingh5SystemFontWeight": "400",
  "bHeadingh5SystemTextAlign": "left",
  "bHeadingh6FontSize": "20px",
  "bHeadingh6Color": "#334444",
  "bHeadingh6LineHeight": "28px",
  "bHeadingh6FontFamily": "Nunito",
  "bHeadingh6FontWeight": "600",
  "bHeadingh6TextAlign": "left",
  "bHeadingh6FallbackFontSize": "16px",
  "bHeadingh6FallbackColor": "#334444",
  "bHeadingh6FallbackLineHeight": "24px",
  "bHeadingh6FallbackFontFamily": "Tahoma",
  "bHeadingh6FallbackFontWeight": "400",
  "bHeadingh6FallbackTextAlign": "left",
  "bHeadingh6SystemFontSize": "16px",
  "bHeadingh6SystemColor": "#334444",
  "bHeadingh6SystemLineHeight": "24px",
  "bHeadingh6SystemFontFamily": "Tahoma",
  "bHeadingh6SystemFontWeight": "400",
  "bHeadingh6SystemTextAlign": "left",
  "bLabelactionFontSize": "16px",
  "bLabelactionColor": "#3377BB",
  "bLabelactionLineHeight": "24px",
  "bLabelactionFontFamily": "Nunito Sans",
  "bLabelactionFontWeight": "700",
  "bLabelactionTextDecoration": "underline",
  "bLabelactionTextAlign": "left",
  "bLabelactionFallbackFontSize": "16px",
  "bLabelactionFallbackColor": "#6699DD",
  "bLabelactionFallbackLineHeight": "24px",
  "bLabelactionFallbackFontFamily": "Tahoma",
  "bLabelactionFallbackFontWeight": "700",
  "bLabelactionFallbackTextDecoration": "underline",
  "bLabelactionFallbackTextAlign": "left",
  "bLabelbuttonFontSize": "20px",
  "bLabelbuttonColor": "#556666",
  "bLabelbuttonLineHeight": "28px",
  "bLabelbuttonFontFamily": "Nunito Sans",
  "bLabelbuttonFontWeight": "700",
  "bLabelbuttonTextAlign": "left",
  "bLabelbuttonFallbackFontSize": "20px",
  "bLabelbuttonFallbackColor": "#556666",
  "bLabelbuttonFallbackLineHeight": "28px",
  "bLabelbuttonFallbackFontFamily": "Tahoma",
  "bLabelbuttonFallbackFontWeight": "700",
  "bLabelbuttonFallbackTextAlign": "left",
  "bLabelformFontSize": "16px",
  "bLabelformColor": "#556666",
  "bLabelformLineHeight": "24px",
  "bLabelformFontFamily": "Nunito Sans",
  "bLabelformFontWeight": "600",
  "bLabelformTextAlign": "left",
  "bLabelformFallbackFontSize": "16px",
  "bLabelformFallbackColor": "#556666",
  "bLabelformFallbackLineHeight": "24px",
  "bLabelformFallbackFontFamily": "Tahoma",
  "bLabelformFallbackFontWeight": "700",
  "bLabelformFallbackTextAlign": "left",
  "bTextparagraphFontSize": "20px",
  "bTextparagraphColor": "#556666",
  "bTextparagraphLineHeight": "28px",
  "bTextparagraphFontFamily": "Nunito Sans",
  "bTextparagraphFontWeight": "300",
  "bTextparagraphTextAlign": "left",
  "bTextparagraphFallbackFontSize": "16px",
  "bTextparagraphFallbackColor": "#556666",
  "bTextparagraphFallbackLineHeight": "24px",
  "bTextparagraphFallbackFontFamily": "Tahoma",
  "bTextparagraphFallbackFontWeight": "400",
  "bTextparagraphFallbackTextAlign": "left",
  "bTextparagraphSystemFontSize": "16px",
  "bTextparagraphSystemColor": "#556666",
  "bTextparagraphSystemLineHeight": "24px",
  "bTextparagraphSystemFontFamily": "Georgia",
  "bTextparagraphSystemFontWeight": "400",
  "bTextparagraphSystemTextAlign": "left",
  "bTextsupportFontSize": "16px",
  "bTextsupportColor": "#556666",
  "bTextsupportLineHeight": "24px",
  "bTextsupportFontFamily": "Nunito Sans",
  "bTextsupportFontWeight": "300",
  "bTextsupportTextAlign": "left",
  "bTextsupportFallbackFontSize": "16px",
  "bTextsupportFallbackColor": "#556666",
  "bTextsupportFallbackLineHeight": "24px",
  "bTextsupportFallbackFontFamily": "Tahoma",
  "bTextsupportFallbackFontWeight": "400",
  "bTextsupportFallbackTextAlign": "left",
  "bTextsupportSystemFontSize": "14px",
  "bTextsupportSystemColor": "#556666",
  "bTextsupportSystemLineHeight": "20px",
  "bTextsupportSystemFontFamily": "Georgia",
  "bTextsupportSystemFontWeight": "400",
  "bTextsupportSystemTextAlign": "left",
  "bTextsupportformFontSize": "14px",
  "bTextsupportformColor": "#556666",
  "bTextsupportformLineHeight": "20px",
  "bTextsupportformFontFamily": "Nunito Sans",
  "bTextsupportformFontWeight": "300",
  "bTextsupportformTextAlign": "left",
  "bTextsupportformFallbackFontSize": "14px",
  "bTextsupportformFallbackColor": "#556666",
  "bTextsupportformFallbackLineHeight": "20px",
  "bTextsupportformFallbackFontFamily": "Tahoma",
  "bTextsupportformFallbackFontWeight": "400",
  "bTextsupportformFallbackTextAlign": "left",
  "bTokenTestFontSize": "16px",
  "bTokenTestColor": "#556666",
  "bTokenTestFontFamily": "Work Sans",
  "bTokenTestFontWeight": "400",
  "bTokenTestTextAlign": "left"
};